'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var FechaConfig = {

    FORMATO_FECHA: 'dd-MM-yyyy',
    FORMATO_FECHA_LARGA: 'dd MMMM yyyy'
};

exports.default = FechaConfig;


// WEBPACK FOOTER //
// ./src/busqueda/config/fecha.config.js